import {
  mfilesConfigState as initialState,
  MfilesConfigStateProps,
} from './mfilesConfig.initialState';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const MfilesConfigSlice = createSlice({
  name: 'MfilesConfig',
  initialState,
  reducers: {
    setMFilesConfig: (
      state,
      action: PayloadAction<MfilesConfigStateProps['data']>
    ) => {
      state.data = { ...action.payload };
    },
    updateMFilesConfig: (
      state,
      action: PayloadAction<Partial<MfilesConfigStateProps['data']>>
    ) => {
      state.data = { ...state.data, ...action.payload };
    },
    // this will return initial state
    clearMFilesConfig: (state) => {
      state.data = initialState.data;
    },
  },

  // Add extra reducers to handle loading states if needed
  extraReducers: (builder) => {},
});

export const { setMFilesConfig, updateMFilesConfig, clearMFilesConfig } =
  MfilesConfigSlice.actions;
export default MfilesConfigSlice.reducer;
